import React from "react";
import {Modal} from "../../hook/useModal";
import AccountSetting from "../auth/AccountSetting";
import useLoginUser from "../../query/auth/useLoginUser";
import {Navigate} from "react-router-dom";
import {useIntl} from "react-intl";
import closeIcon from "../../assets/svgs/icon_close_black_24.svg";

export const HOME_ACCOUNT_SETTING_MODAL_ID = "home-account-setting-modal-id";


const HomeAccountSettingModal: React.FC = () => {
    const intl = useIntl();
    const {data: profile, isLoading} = useLoginUser();

    if (isLoading) return <></>;

    if (!profile) {
        return <Navigate to={"/login"}/>
    }

    return (
        <Modal id={HOME_ACCOUNT_SETTING_MODAL_ID}
               title={<p className="leading-[64px] text-[20px] font-pretendard font-semibold px-[32px] pt-5 pb-[10px] text-console-black">{intl.formatMessage({id: "i0063"})}</p>}
               className="!p-0 overflow-visible"
               size="md"
               showCloseButton={true}
               customCloseButton={<img src={closeIcon} alt="close" className="absolute right-[10px] top-[10px] w-[24px] h-[24px] cursor-pointer"/>}
        >
            <div className="flex flex-col px-[56px] pb-[46px]">
                <AccountSetting profile={profile}
                                containerClassName="flex flex-col space-y-10"
                />
            </div>
        </Modal>
    );
};

export default HomeAccountSettingModal;
